var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vx-col w-full" },
    [
      _c("vx-card", { attrs: { title: "Driver List" } }, [
        _c(
          "div",
          {
            key: _vm.key,
            staticClass: "mt-4",
            attrs: { slot: "no-body" },
            slot: "no-body"
          },
          [
            _c(
              "vs-table",
              {
                staticClass: "table-dark-inverted",
                attrs: { data: _vm.drivers, search: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var data = ref.data
                      return _vm._l(data, function(tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr },
                          [
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].first_name } },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(data[indextr].first_name) +
                                      " " +
                                      _vm._s(data[indextr].last_name)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2" }, [
                                  _vm._v(_vm._s(data[indextr].email))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2" }, [
                                  _vm._v(_vm._s(data[indextr].phonenumber))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].stats } },
                              [
                                _c("vs-button", {
                                  attrs: {
                                    color: data[indextr].is_online
                                      ? "#469600"
                                      : "#bc1254",
                                    type: "flat",
                                    icon: "fiber_manual_record",
                                    title: data[indextr].is_online
                                      ? "Online"
                                      : "Offline"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].id } },
                              [
                                _c("vs-button", {
                                  attrs: {
                                    type: "gradient",
                                    icon: "create",
                                    radius: "",
                                    title: "Select"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onClickSelectDriver(
                                        data[indextr]
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    }
                  }
                ])
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", { attrs: { "sort-key": "name" } }, [
                      _vm._v("Description")
                    ]),
                    _vm._v(" "),
                    _c("vs-th", [_vm._v("ONLINE")]),
                    _vm._v(" "),
                    _c("vs-th", [_vm._v("SELECT")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }